import { createI18n } from 'vue-i18n'


const SUPPORTED_LOCALES = ['en'] as const
const DEFAULT_LOCALE = SUPPORTED_LOCALES[0]

export const i18nInstance = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  messages: {},
})

export const i18n = i18nInstance.global
